module.exports = __webpack_public_path__ + "static/img/5.c8e093e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/eng/5.png
// module id = 1uxy
// module chunks = 0